module.exports = __webpack_public_path__ + "static/media/addphoto.10c6e8cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/addphoto.svg
// module id = ./src/statics/images/addphoto.svg
// module chunks = 0